module.exports = __webpack_public_path__ + "VIPV6.png?c15b0a518e0c65057df7e098591aa01d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV6.png
// module id = 139
// module chunks = 0